import React from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
function ProjectInvitationCustomTextbox(_ref) {
  var consultantFirstName = _ref.consultantFirstName,
    updateParentMessage = _ref.updateParentMessage,
    customMessage = _ref.customMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group question custom-message italicized-placeholder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-8"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "custom-message"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "regular-spacing"
  }, "Message to ".concat(consultantFirstName, " (Optional):")))), /*#__PURE__*/React.createElement(TextareaAutosize, {
    type: "text",
    className: "form-control form-control--light",
    name: "consultant-custom-message",
    id: "consultant-custom-message",
    rows: 5,
    placeholder: "Hi ".concat(consultantFirstName, ",\nI\u2019d like to invite you to take a look at the project I have just posted. Please submit a proposal if you\u2019re interested."),
    onChange: function onChange(e) {
      return updateParentMessage(e.target.value);
    },
    value: customMessage
  }));
}
ProjectInvitationCustomTextbox.propTypes = {
  consultantFirstName: PropTypes.string.isRequired,
  updateParentMessage: PropTypes.func,
  customMessage: PropTypes.string.isRequired
};
ProjectInvitationCustomTextbox.defaultProps = {
  updateParentMessage: function updateParentMessage() {}
};
export default ProjectInvitationCustomTextbox;